import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './components/layout';
import {Provider} from 'unstated';
import {ragas} from './ragas';

ReactDOM.render(
    <Provider>
    <Layout ragas={ragas}/> </Provider>,
    document.getElementById('app')
);

//window.Tone = Tone;


//let noteinText = "";


// window.addEventListener('DOMContentLoaded', () => {


//     document.querySelector("#s").addEventListener("click",() =>{
//         console.log("s is clicked");
//         noteinText+="s" + " ";
//         document.querySelector("#notes").innerHTML = noteinText;
//         player.play(noteinText);
//     });
//     document.querySelector("#r1").addEventListener("click",() =>{
//         console.log("r1 is clicked");
//         noteinText+="r1" + " ";
//         document.querySelector("#notes").innerHTML = noteinText;
//         player.play(noteinText);
//     });
//     document.querySelector("#play").addEventListener("click", () => {
//         console.log("I should play");
//        // let raga = document.querySelector("select#raga").value;
//         // let notes = ragas[raga].split(" ");
//         let phrase = document.querySelector("select#raga").value;
//         let notes = phrases[phrase].split(" ");
//         player.play(notes);
//     });

//     //Old code that had a HTML select option box
//     /*document.querySelector("#raga").addEventListener('click', () => {
//         console.log("I have been called");
//         let raga = document.querySelector("select#raga").value;
//         document.querySelector("#notes").innerHTML = phrases[raga];
//        // document.querySelector("textarea#notes-input").innerText = ragas[raga];
//     });*/
//     document.querySelector("#stop").addEventListener("click", () => {
//         console.log('Playing should stop');
//         player.stop();
//     });
//     //Bulma dropdown box
//     document.querySelector(".dropdown.raga-selector").addEventListener("click", (e)=> {
//         console.log(e);
//         if(document.querySelector(".dropdown.raga-selector.is-active")!==null) {
//             document.querySelector(".dropdown.raga-selector").classList.remove("is-active");
//             return;
//         }
//         document.querySelector(".dropdown.raga-selector").classList.add("is-active");
        
//     });

//     let ragaset = document.querySelectorAll(".dropdown.raga-selector .dropdown-item")
//     ragaset.forEach((dItem) => {
//         dItem.addEventListener("click", (e) => {
//             document.querySelector(".dropdown.raga-selector .dd-text").innerHTML = e.target.innerHTML;
//             console.log(e.target.dataset.ragaId);
//         });
    
//     });
//     //This below logic is for checking swaras
//     /*
//     document.querySelector("#check").addEventListener("click", () => {
//         let raga = document.querySelector("select#raga").value;
//         let notes = ragas[raga].split(" ");
//         let answer = document.querySelector("textarea#notes-input").value;
//         //let answer = document.querySelector("select#answer").value;
//         let ans = answer.split(",");
//         let result = player.check(notes, ans);
//         document.querySelector("textarea#result-output").innerText = result;
//     })
//     */
// });

